import React, { useState } from 'react';
import { useProjectModel } from '../../../model.js';
import { generateCustomElement } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import {
  ChooseDashboardPageStep,
  ChooseElementFolderStep,
  ChooseElementNameStep,
  LinkDashboardPageStep,
} from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateCustomElement = () => {
  const { model } = useProjectModel();

  const [elementName, setElementName] = useState<string>();
  const [elementFolder, setElementFolder] = useState<string>();
  const [linkDashboardPage, setLinkDashboardPage] = useState<boolean>();
  const [dashboardPageId, setDashboardPageId] = useState<string>();

  const shouldGenerate = linkDashboardPage === false ? true : dashboardPageId;

  const generationTask = useGenerationTask(async () => {
    if (elementName && elementFolder && shouldGenerate) {
      return generateCustomElement(
        model.projectFolder,
        elementFolder,
        elementName,
        dashboardPageId
      );
    }
  }, [elementFolder, elementName, shouldGenerate]);

  return [
    <ChooseElementNameStep
      onSubmit={setElementName}
      elementName={elementName}
    />,
    <ChooseElementFolderStep
      onSubmit={setElementFolder}
      elementFolder={elementFolder}
      elementName={elementName}
    />,
    <LinkDashboardPageStep onSubmit={setLinkDashboardPage} />,
    ...(linkDashboardPage
      ? [<ChooseDashboardPageStep onSubmit={setDashboardPageId} />]
      : []),
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'custom element'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/site-widgets/add-a-site-widget-extension
        learnMoreUrl: 'https://wix.to/6aKN8aH',
      })}
    />,
  ];
};
